import React from "react";
import MicRoundedIcon from "@mui/icons-material/MicRounded";
import VideoCameraBackRoundedIcon from "@mui/icons-material/VideoCameraBackRounded";
import ScreenShareRoundedIcon from "@mui/icons-material/ScreenShareRounded";
import { GraphType } from "@services/monitoring/types";

const ChartTypeIcon = ({ graphType }: { graphType: GraphType }) => {
  switch (graphType) {
    case GraphType.Jitter_Audio:
      return <MicRoundedIcon />;
    case GraphType.Call_Rate:
    case GraphType.Jitter_Video:
    case GraphType.Packet_Loss:
    case GraphType.Frame_Rate:
      return <VideoCameraBackRoundedIcon />;
    case GraphType.Bit_Rate_Content:
    case GraphType.Jitter_Content:
    case GraphType.Packet_Loss_Percentage_Content:
    case GraphType.Frame_Rate_Content:
    default:
      return <ScreenShareRoundedIcon />;
  }
};

export default ChartTypeIcon;
